Vue.component( 'proms-timeline', {

    props: {
        data: Array,
    },

    data() {
        return {
            chartOptions: {
                chartArea: {
                    width: '100%',
                },
                hAxis: {
                },
                vAxis: {
                    textPosition: 'none',
                    gridlines: {
                        count: 0,
                    },
                },
                legend: 'none',
                animation: {
                    duration: 250,
                    easing: 'inAndOut',
                    startup: true,
                },
                interpolateNulls: true,
                focusTarget: 'category',
            },
        };
    },

    template: `<div class="proms-timeline">
        <ul class="proms-timeline-overview">
            <li v-for="( overviewItem, index ) of overviewItems" v-bind:key="index">
                <span v-bind:style="{ color: overviewItem.color }">{{overviewItem.value}}</span> {{overviewItem.label}}
            </li>
        </ul>
        <google-chart v-if="hasData" type="LineChart" v-bind:table="data" v-bind:options="chartOptions"></google-chart>
    </div>`,

    computed: {

        hasData() {
            return this.data && this.data.length && this.data[0].length;
        },

        overviewItems() {
            let header = [];
            let lastMonthData = [];

            let colors = [
                // Old colours
                // '#857F99',
                // '#49ABFF',
                // '#FFC000',

                // Google Charts Defaults
                '#3366CC',
                '#DC3912',
                '#FF9900',
                '#109618',
                '#990099',
            ];
            let nextColor = ( index => () => colors[ index++ % colors.length ] )( 0 );

            if ( this.hasData ) {
                let data = _.cloneDeep( this.data );

                header = data.shift();
                let lastMonth = data.pop() || ( new Array( header.length ).fill( 'N/A' ) );

                // Remove date column from rows
                header.shift();
                lastMonth.shift();

                // Combine keys and values
                lastMonthData = _.zipObject( header, lastMonth );
            }

            return header.map( label => ( {
                label,
                value: lastMonthData[ label ],
                color: nextColor(),
            } ) );
        },

    },

} );

Vue.component( 't-score-comparison-tabs', {

    props: {
        tabs: Object,
    },

    data() {
        return {
            activeData: null,
            activeTabIndex: 0,
        };
    },

    template: `<div class="t-score-comparison-tabs">
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item"
                v-for="( data, title, index ) of tabs" v-bind:key="index"
            >
                <a class="nav-link"
                    href="#"
                    v-bind:class="{ active: index === activeTabIndex }"
                    v-on:click.prevent="switchTab( index, data )"
                >{{ title }}</a>
            </li>
        </ul>

        <div class="tab-content">
            <div class="tab-pane fade show active">
                <t-score-comparison-chart v-bind:data="activeData"></t-score-comparison-chart>

                <p class="small" style="margin-left: 180px;">
                    Lower fatigue, pain intensity, and pain interference scores refer to better quality of life.
                    Lower physical function scores refer to poorer quality of life.
                </p>
            </div>
        </div>
    </div>`,

    methods: {

        switchTab( index, data ) {
            this.activeTabIndex = index;
            this.activeData = data;
        },

    },

    mounted() {
        let firstTab = Object.keys( this.tabs )[ 0 ];
        this.switchTab( 0, this.tabs[ firstTab ] );
    },

} );

Vue.component( 't-score-comparison-chart', {

    props: {
        data: Object,
    },

    data() {
        return {
            table: [],
            chartOptions: {
                chartArea: {
                },
                hAxis: {
                },
                vAxis: {
                    title: 'T-Score (mean ± SD)\nGeneral US Population: 50 ± 10',
                    titleTextStyle: {
                        italic: false,
                    },
                    viewWindow: {
                        max: 80,
                        min: 20,
                    },
                    baseline: 50,
                    direction: -1,
                },
                legend: {
                    position: 'bottom',
                    alignment: 'start',
                },
                seriesType: 'bars',
                series: [
                    { visibleInLegend: false }, // 7 days
                    { visibleInLegend: false }, // 30 days
                    { visibleInLegend: false }, // 180 days
                ],
                animation: {
                    duration: 250,
                    easing: 'inAndOut',
                    startup: true,
                },
                interpolateNulls: true,
            },
        };
    },

    template: `<div class="t-score-comparison-chart">
        <google-chart type="ComboChart" v-bind:table="table" v-bind:options="chartOptions"></google-chart>
    </div>`,

    watch: {

        data: function() {
            this.updateTable();
        },

    },

    methods: {

        updateTable() {

            let table = {
                series: [ 'Group' ],
                user: [ 'Your Average' ],
                location: [ 'Institution Average' ],
                country: [ 'Country Average' ],
                world: [ 'World Average' ],
            };

            let legend = _.zip( this.data.legend.labels, this.data.legend.colors );

            for ( let row of this.data.data ) {
                for ( let column of Object.keys( table ) ) {
                    let style = null;
                    let value = row[ column ];
                    if ( column === 'series' ) {
                        style = { role: 'style' };
                        value = { type: 'number', label: value };
                    } else if ( row.color && row.color[ column ] ) {
                        style = `color: ${row.color[ column ]}`;
                    }
                    table[ column ].push( value, style );
                }
            }

            for ( let [label, color] of legend ) {
                for ( let column of Object.keys( table ) ) {
                    table[ column ].push( column === 'series' ? { type: 'number', label } : undefined );
                }
                this.chartOptions.series.push( {
                    color,
                    type: 'line',
                    pointShape: 'circle',
                    pointSize: 20,
                    lineWidth: 0,
                } );
            }

            this.table = Object.values( table );

            this.chartOptions.vAxis.direction = ( this.data.invert || false ) ? 1 : -1;
        },

    },

} );

Vue.component( 'net-promoter', {

    props: {
        value: Number,
    },

    template: `<div class="net-promoter">
        <net-promoter-emoji v-bind:value="value"></net-promoter-emoji>
        <h2>Net Promoter</h2>
        <h3>{{ value }}</h3>
    </div>`,

} );

Vue.component( 'net-promoter-emoji', {

    props: {
        value: Number,
    },

    data() {
        return {
            emojiLookup: {
                '0': '🙁',
                '1': '🙁',
                '2': '🙁',
                '3': '🙁',
                '4': '🙁',
                '5': '🙁',
                '6': '🙁',
                '7': '😐',
                '8': '😐',
                '9': '🙂',
                '10': '🙂',
            },
        };
    },

    template: `<div class="net-promoter-emoji">{{ emojiLookup[ Math.round( value ) ] || '❓' }}</div>`,

} );
